import React from 'react';
import './Disclosures.css';

const Disclosures = () => (
  <div className="page-container dark-red-theme">
    <h2>Mandatory Disclosures</h2>
    <p>Dummy content for Mandatory Disclosures page.</p>
  </div>
);

export default Disclosures;
